import React, { useRef, useState } from "react";
import "./PaiementJournalier.scss";
import { ChromeReaderModeRounded, Close } from "@mui/icons-material";
import "react-phone-input-2/lib/style.css";
import { Typography } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import { EleveType, PaiementType } from "../../types/GlobalType";
import moment, { now } from "moment";
import _ from "lodash";
import NoData from "../nodata/NoData";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  dataPaiement: PaiementType[];
  dataEleve: EleveType[];
}

const PaiementJournalier = (props: Props) => {
  const orderedData = _.orderBy(
    props.dataPaiement,
    ["paiement_created_at"],
    ["desc"]
  );

  const printRef = useRef<HTMLTableElement>(null);

  const handleClickPrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: ".",
  });

  const [date, setdate] = useState(moment().format("YYYY-MM-DD"));

  const handleDateChange = (e) => {
    let d = moment(e.target.value).format("YYYY-MM-DD");
    setdate(d);
  };

  const filteredDataByDate = orderedData.filter((item) => {
    return item.paiement_created_at.includes(date);
  });

  return (
    <div className="paiementJournalier">
      <div className="dialog">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <ChromeReaderModeRounded color="primary" sx={{ fontSize: 17 }} />
              <Typography
                variant="h6"
                color="primary"
                sx={{ fontWeight: "500", fontSize: 15 }}
              >
                Historique des paiements
              </Typography>
            </div>
            <div className="right_">
              <input type="date" value={date} onChange={handleDateChange} />
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </div>
          </div>
        </div>

        <div className="body">
          {filteredDataByDate.length === 0 ? (
            <NoData />
          ) : (
            <table ref={printRef}>
              <thead>
                <tr>
                  <th>Id</th>
                  {/* <th>Matricule</th> */}
                  <th>Noms</th>
                  <th>Classe</th>
                  <th>Montant</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {filteredDataByDate.map((value, index) => {
                  // let uuid: string | undefined = "";
                  let noms: string = "";
                  for (let item of props.dataEleve) {
                    if (item.eleve_id === value.eleve_id) {
                      noms = `${item.nom} ${item.postnom} ${item.prenom}`;
                      // uuid = item.eleve_uid;
                    }
                  }
                  return (
                    <tr key={index}>
                      <td>{`0${index + 1}`}</td>
                      {/* <td>{uuid}</td> */}
                      <td>{noms.toUpperCase()}</td>
                      <td>{value.classe_designation}</td>
                      <td>{value.montant}$</td>
                      <td>
                        {moment(value.paiement_created_at).format("DD-MM-YYYY")}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        <div className="btn">
          <button onClick={() => props.setOpen(false)}>Retourner</button>
          <button onClick={handleClickPrint}>Imprimer</button>
        </div>
      </div>
    </div>
  );
};

export default PaiementJournalier;
